module.exports = __webpack_public_path__ + "static/media/ChristmasCard.c3570ac0.jpg";